import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

import styles from 'assets/jss/material-dashboard-pro-react/components/customInputStyle';

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
	const classes = useStyles();
	const {
		formControlProps,
		labelText,
		id,
		labelProps,
		inputProps,
		error,
		white,
		inputRootCustomClasses,
		success,
		helperText,
		helperTextClassName: helperTextClassNameProp,
		onChange,
		onBlur,
		onClear = () => {},
		clearable,
	} = props;

	const labelClasses = classNames({
		[' ' + classes.labelRootError]: error,
		[' ' + classes.labelRootSuccess]: success && !error
	});
	const underlineClasses = classNames({
		[classes.underlineError]: error,
		[classes.underlineSuccess]: success && !error,
		[classes.underline]: true,
		[classes.whiteUnderline]: white
	});
	const marginTop = classNames({
		[inputRootCustomClasses]: inputRootCustomClasses !== undefined
	});
	const inputClasses = classNames({
		[classes.input]: true,
		[classes.whiteInput]: white,
		[classes.clearableInput]: clearable,
		[classes.clearableAndStartIconInput]: clearable && inputProps.startAdornment,
	});
	let formControlClasses;
	if (formControlProps !== undefined) {
		formControlClasses = classNames(
			formControlProps.className,
			classes.formControl
		);
	} else {
		formControlClasses = classes.formControl;
	}
	let helpTextClasses = classNames({
		[classes.helperText]: true,
		[' ' + classes.labelRootError]: error,
		[classes.labelRootSuccess]: success && !error
	});
	let newInputProps = {
		maxLength:
			inputProps && inputProps.maxLength ? inputProps.maxLength : undefined,
		minLength:
			inputProps && inputProps.minLength ? inputProps.minLength : undefined
	};

	const clearIcon = (
		<IconButton
			aria-label="clear"
			size="small"
			onClick={onClear}
			className={classes.clearButton}
		>
			<ClearIcon fontSize="small"/>
		</IconButton>
	);

	return (
		<FormControl {...formControlProps} className={formControlClasses}>
			{labelText !== undefined ? (
				<InputLabel
					className={`${classes.labelRoot} ${labelClasses}`}
					htmlFor={id}
					{...labelProps}
				>
					{labelText}
				</InputLabel>
			) : null}
			<Input
				classes={{
					input: inputClasses,
					root: marginTop,
					disabled: classes.disabled,
					underline: underlineClasses
				}}
				id={id}
				{...inputProps}
				inputProps={newInputProps}
				onChange={onChange}
				onBlur={onBlur}
				endAdornment={(inputProps.value && clearable) && clearIcon}
			/>
			{helperText !== undefined ? (
				<FormHelperText id={id + '-text'} className={`${helpTextClasses} ${helperTextClassNameProp}`}>
					{helperText}
				</FormHelperText>
			) : null}
		</FormControl>
	);
}

CustomInput.propTypes = {
	labelText: PropTypes.node,
	labelProps: PropTypes.object,
	id: PropTypes.string,
	inputProps: PropTypes.object,
	formControlProps: PropTypes.object,
	inputRootCustomClasses: PropTypes.string,
	error: PropTypes.bool,
	success: PropTypes.bool,
	white: PropTypes.bool,
	helperText: PropTypes.node
};
